module.exports = __webpack_public_path__ + "img/tishi.5530422c.png";